export default "__VITE_ASSET__6LmS2v7m__"